import LoadingSpinner from "../components/LoadingSpinner";

function SplashScreen() {

  return (
    <div className="h-screen w-screen flex justify-center items-center" >
      <LoadingSpinner size={150} />
    </div>
  );
}

export default SplashScreen;
